exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".le7ku3.tai5 ruby{margin-right:6px;font-size:1.7rem}.le7ku3.tai5 ruby rt{font-size:1.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/例句/漢字臺羅一詞.css
// module id = 659
// module chunks = 0